import React, { useContext, useEffect, useMemo, useState } from 'react';
import 'chart.js/auto';
import { Spin } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import StatisticsChart from '../admin/statistics/StatisticsChart';
import "./StatisticsPageView.scss";
import StatisticsFilter, { Filter } from './StatisticsFilter';
import { useStatisticsServiceGetStatistics360Spin, useStatisticsServiceGetStatistics360SpinKey, useStatisticsServiceGetStatisticsAsset, useStatisticsServiceGetStatisticsAssetKey, useStatisticsServiceGetStatisticsCutout, useStatisticsServiceGetStatisticsCutoutKey, useStatisticsServiceGetStatisticsDamupload, useStatisticsServiceGetStatisticsDamuploadKey, useStatisticsServiceGetStatisticsInsitu, useStatisticsServiceGetStatisticsInsituKey, useStatisticsServiceGetStatisticsProject, useStatisticsServiceGetStatisticsProjectKey, useStatisticsServiceGetStatisticsScene, useStatisticsServiceGetStatisticsSceneKey, useStatisticsServiceGetStatisticsStyling, useStatisticsServiceGetStatisticsStylingKey, useStatisticsServiceGetStatisticsUsage, useStatisticsServiceGetStatisticsUsageKey, useStatisticsServiceGetStatisticsUsagepreview, useStatisticsServiceGetStatisticsVideo, useStatisticsServiceGetStatisticsVideoKey, useUserServiceGetUserClient, useUserServiceGetUserClientKey } from '../../openapi/queries';
import { ConfigContext } from '../../contexts/ConfigContext';
import dayjs from 'dayjs'
import StatisticsUsage from '../admin/statistics/StatisticsUsage';
import ToggleButton from '../layout/elements/ToggleButton';
import { ChartDTO } from '../../openapi/requests';


const StatisticsPageView: React.FC = () => {

    const { currentClient } = useContext(ConfigContext);

    const [usersData, setUsersData] = useState<DefaultOptionType[]>([]);
    const [filters, setFilters] = useState<Filter[]>([]);
    const [DAMfilters, setDAMFilters] = useState<Filter[]>([]);
    const [displayData, setDisplayData] = useState<string[]>(['current'])

    const [displayMode, setDisplayMode] = useState<string>("");

    const { data: users } = useUserServiceGetUserClient([useUserServiceGetUserClientKey, currentClient], { refetchOnWindowFocus: false });

    const mappedFilters = useMemo(() => {

        let dateValues = filters.find(x => x.property === "date");
        let startDate = dayjs('2023-11-01')
        let endDate = dayjs().endOf("week");

        if (dateValues && dateValues.values.length > 0) {
            startDate = dayjs(dateValues.values[0]);

            if (dateValues.values.length > 1)
                endDate = dayjs(dateValues.values[1]);
        }

        let userValue = filters.find(x => x.property === "user");
        let userId = null;
        if (userValue) {
            userId = userValue.values[0].value;
        }

        let intervalValue = filters.find(x => x.property === "interval");
        let interval = "month";
        if (intervalValue) {
            interval = intervalValue.values[0].value;
        }

        let renderTypeValue = filters.find(x => x.property === "rendertype");
        let renderType = "final";
        if (renderTypeValue) {
            renderType = renderTypeValue.values[0].value;
        }

        if (displayMode === "lastyear") {
            startDate = dayjs().set("month", 1).startOf("month");
            endDate = dayjs().add(1, "year").set("month", 0).endOf("month");
            interval = "month";
            userId = null;
        }

        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
            dateInterval: interval,
            renderType: renderType,
            userId: userId,
            isEnabled: true,
            clientId: currentClient.id,
            displayMode: displayMode
        }

    }, [currentClient.id, filters, displayMode]);

    const mappedDAMFilters = useMemo(() => {

        let dateValues = DAMfilters.find(x => x.property === "date");
        let startDate = dayjs('2023-11-01')
        let endDate = dayjs().endOf("week");

        if (dateValues && dateValues.values.length > 0) {
            startDate = dayjs(dateValues.values[0]);

            if (dateValues.values.length > 1)
                endDate = dayjs(dateValues.values[1]);
        }       

        let intervalValue = DAMfilters.find(x => x.property === "interval");
        let interval = "month";
        if (intervalValue) {
            interval = intervalValue.values[0].value;
        }

        let userValue = filters.find(x => x.property === "user");
        let userId = null;
        if (userValue) {
            userId = userValue.values[0].value;
        }

        let templateTypeValue = DAMfilters.find(x => x.property === "templateType");
        let templateType = "";
        if (templateTypeValue) {
            templateType = templateTypeValue.values[0].value;
        }
        
        if (displayMode === "lastyear") {
            startDate = dayjs().set("month", 1).startOf("month");
            endDate = dayjs().add(1, "year").set("month", 0).endOf("month");
            interval = "month";
            userId = null;
        }    

        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
            dateInterval: interval,          
            userId: userId,
            isEnabled: true,        
            templateType: templateType,   
            displayMode: displayMode
        }

    },[DAMfilters, displayMode, filters])

    //  const { data: statistics, isFetched: statisticsFetched } = useStatisticsServiceGetStatistics({ ...mappedFilters }, [useStatisticsServiceGetStatisticsKey, mappedFilters], { refetchOnWindowFocus: false });

    const { data: insituData, isFetched: insituStatisticsFetched } = useStatisticsServiceGetStatisticsInsitu({ ...mappedFilters }, [useStatisticsServiceGetStatisticsInsituKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: cutoutData, isFetched: cutoutStatisticsFetched } = useStatisticsServiceGetStatisticsCutout({ ...mappedFilters }, [useStatisticsServiceGetStatisticsCutoutKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: spin360Data, isFetched: spin360StatisticsFetched } = useStatisticsServiceGetStatistics360Spin({ ...mappedFilters }, [useStatisticsServiceGetStatistics360SpinKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: videoData, isFetched: videoStatisticsFetched } = useStatisticsServiceGetStatisticsVideo({ ...mappedFilters }, [useStatisticsServiceGetStatisticsVideoKey, mappedFilters], { refetchOnWindowFocus: false });

    const { data: assetsData, isFetched: assetsStatisticsFetched } = useStatisticsServiceGetStatisticsAsset({ ...mappedFilters }, [useStatisticsServiceGetStatisticsAssetKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: scenesData, isFetched: scenesStatisticsFetched } = useStatisticsServiceGetStatisticsScene({ ...mappedFilters }, [useStatisticsServiceGetStatisticsSceneKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: stylingData, isFetched: stylingStatisticsFetched } = useStatisticsServiceGetStatisticsStyling({ ...mappedFilters }, [useStatisticsServiceGetStatisticsStylingKey, mappedFilters], { refetchOnWindowFocus: false });

    const { data: projectsData, isFetched: projectsStatisticsFetched } = useStatisticsServiceGetStatisticsProject({ ...mappedFilters }, [useStatisticsServiceGetStatisticsProjectKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: DAMuploadsData, isFetched: DAMuploadsStatisticsFetched } = useStatisticsServiceGetStatisticsDamupload({ ...mappedDAMFilters }, [useStatisticsServiceGetStatisticsDamuploadKey, mappedDAMFilters], { refetchOnWindowFocus: false });

    const { data: usage, isFetched: usageFetched } = useStatisticsServiceGetStatisticsUsage({ ...mappedFilters }, [useStatisticsServiceGetStatisticsUsageKey, currentClient], { refetchOnWindowFocus: false });
    const { data: usagePreview, isFetched: usagePreviewFetched } = useStatisticsServiceGetStatisticsUsagepreview({ ...mappedFilters }, [useStatisticsServiceGetStatisticsUsageKey, currentClient], { refetchOnWindowFocus: false });


    const dateIntervalOptions = [
        { label: "Week", value: "week" },
        { label: "Month", value: "month" },
        { label: "Quarter", value: "quarter" },
        { label: "Year", value: "year" }
    ];

    const templateTypeOptions = [        
        { label: "In-situ", value: "insitu"},
        { label: "Cutout", value: "cutout"},
        { label: "360 Spin", value: "spin360"},
        { label: "Video", value: "video"}
    ];

    type StatisticsFilterProperties = {
        defaultValue?: string,
        clearable?: boolean;
        name: string,
        property: string,
        type: string,
        items: any;
    }

    let properties = Array<StatisticsFilterProperties>()
    let DAMproperties = Array<StatisticsFilterProperties>()

    properties = [
        { name: 'Date', property: 'date', type: 'daterange', items: [] },
        { name: 'Interval', property: 'interval', type: 'select', items: dateIntervalOptions, defaultValue: "month" },
        { name: 'User', property: 'user', type: 'select', items: usersData ?? [], clearable: true }
    ];
    
    DAMproperties = [
        { name: 'Type', property: 'templateType', type: 'select', items: templateTypeOptions, clearable: true },
    ];

    useEffect(() => {
        setUsersData(users?.map(x => ({ label: x.username, value: x.id.toString() })) ?? []);
    }, [users])

    const onChange = (filters: Filter[]) => {
        var updatedFilters = filters.filter(x => x.values.length > 0);
        setFilters([...updatedFilters]);
    }

    const onChangeDAM = (filters: Filter[]) => {
        var updatedFilters = filters.filter(x => x.values.length > 0);
        setDAMFilters([...updatedFilters]);
    }

    const onShowLastYear = (toggled: boolean) => {

        let displayData = ["current"];
        let displayMode = ""
        if (toggled) {
            displayData.push("lastyear");
            displayMode = "lastyear";
        }
        setDisplayData(displayData)
        setDisplayMode(displayMode);

    }

    return (
        <div className='statistics-page-view'>

            <div className='statistics-page-usage'>
                <Spin spinning={!usageFetched}>
                    {usageFetched ? <StatisticsUsage label="Actual usage vs. License Agreement" showLimit={true} items={usage} /> : null}
                </Spin>
                <Spin spinning={!usagePreviewFetched}>
                    {usagePreviewFetched ? <StatisticsUsage label="Preview" showLimit={false} items={usagePreview} /> : null}                
                </Spin>
            </div>

            <div className='statistics-filters-wrapper'>
                <StatisticsFilter isOpen={true} filters={filters} onChange={onChange} properties={properties} disabled={displayMode.length > 0} />
                <ToggleButton className='has-icon button secondary' onToggle={onShowLastYear}>Compare Last/Current Fiscal Year</ToggleButton>
            </div>

            <div className='statistics-page-charts'>

                <div className='statistics-page-charts-body'>
                    <h1>Assets Generated</h1>
                    <StatisticsChartWrapper data={insituData} fetched={insituStatisticsFetched} displayData={displayData}/>
                    <StatisticsChartWrapper data={cutoutData} fetched={cutoutStatisticsFetched} displayData={displayData}/>
                    <StatisticsChartWrapper data={spin360Data} fetched={spin360StatisticsFetched} displayData={displayData}/>
                    <StatisticsChartWrapper data={videoData} fetched={videoStatisticsFetched} displayData={displayData}/>
                </div>

                <div className='statistics-page-charts-body'>
                        <h1>Assets Implemented</h1>
                        <StatisticsChartWrapper data={assetsData} fetched={assetsStatisticsFetched} displayData={displayData}/>
                        <StatisticsChartWrapper data={scenesData} fetched={scenesStatisticsFetched} displayData={displayData}/>
                        <StatisticsChartWrapper data={stylingData} fetched={stylingStatisticsFetched} displayData={displayData}/>                    
                    </div>

                    <div className='statistics-page-charts-body'>
                        <h1>DAM Uploads</h1>
                        <StatisticsFilter isOpen={true} filters={DAMfilters} onChange={onChangeDAM} properties={DAMproperties} />
                        <StatisticsChartWrapper data={DAMuploadsData} fetched={DAMuploadsStatisticsFetched} displayData={displayData}/>                       
                    </div>

                    <div className='statistics-page-charts-body'>
                        <h1>Projects Created</h1>
                        <StatisticsChartWrapper data={projectsData} fetched={projectsStatisticsFetched} displayData={displayData}/>                    
                    </div>

            </div>

        </div>
    )
}

const StatisticsChartWrapper: React.FC<{data: ChartDTO, fetched: boolean, displayData?: string[]}> = ({data,fetched, displayData}) => {

    return (
        <div className="statistics-page-chart">
        {!fetched ? <div className="statistics-loader"><Spin spinning={!fetched} /></div> : null}
        <div className='statistics-page-chart-body'>
            {data && data.data.map(chartData => (
                <div className="statistics-chart-wrapper" key={data.id + "_" + chartData.name}>
                    <h2>{chartData.name}</h2>
                    <StatisticsChart labels={data.labels} chartData={chartData} color="#adadad" displayData={displayData ?? []} />
                </div>
            ))}
        </div>
    </div>
  )

}


export default StatisticsPageView;